import { Skeleton } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import UserBulkUploadEditForm from "./userBulkUploadEditForm";
import { fetchBulkUploadReviewUser } from "redux/actions/users/usersData";

// User Bulk Upload - Edit page
const UserBulkUploadEdit = () => {
  const dispatch = useDispatch();
  const { UploadStep, Id } = useParams();
  const userOrganization = useSelector((e) => e.sidebar.organisation);
  const userBulkUploadEditLoading = useSelector(
    (e) => e.users.userBulkUploadEditLoading
  );
  const usersSkeletonData = useSelector((e) => e.users.skeletonData);

  useEffect(() => {
    if (userOrganization && UploadStep === "step2") {
      dispatch(fetchBulkUploadReviewUser({ Id }));
    }
  }, [userOrganization, Id]);

  return (
    <div className="container-fluid dt-ta-prog-modules-create-wrapper">
      {userBulkUploadEditLoading ? (
        // Loading screen when question details are loading
        <div>
          {usersSkeletonData.map((skData, index) => (
            <Skeleton
              key={index}
              sx={{ marginBottom: skData.marginBottom }}
              variant="rectangular"
              height={skData.height}
            />
          ))}
        </div>
      ) : (
        <div className="dt-ta-prog-modules-create">
          <UserBulkUploadEditForm />
        </div>
      )}
    </div>
  );
};

export default UserBulkUploadEdit;
